import { render, staticRenderFns } from "./CurrenciesPayments.vue?vue&type=template&id=590f1e06&scoped=true"
import script from "./CurrenciesPayments.vue?vue&type=script&lang=js"
export * from "./CurrenciesPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590f1e06",
  null
  
)

export default component.exports